import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (get) => (name) => get(name)?.isCustodial ?? false;
export default defineSelectorResultFunction({
    id: 'isCustodial',
    resultFunction,
    dependencies: [
        { selector: 'get' },
    ],
});
